var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1C7.5047 1 1 7.5047 1 15.5V21.5074C1 22.9922 2.30065 24.2 3.9 24.2H5.35C5.73456 24.2 6.10338 24.0472 6.3753 23.7753C6.64723 23.5034 6.8 23.1346 6.8 22.75V15.2927C6.8 14.9081 6.64723 14.5393 6.3753 14.2673C6.10338 13.9954 5.73456 13.8427 5.35 13.8427H4.0334C4.8396 8.23115 9.6681 3.9 15.5 3.9C21.3319 3.9 26.1604 8.23115 26.9666 13.8427H25.65C25.2654 13.8427 24.8966 13.9954 24.6247 14.2673C24.3528 14.5393 24.2 14.9081 24.2 15.2927V24.2C24.2 25.7994 22.8994 27.1 21.3 27.1H18.4V25.65H12.6V30H21.3C24.4987 30 27.1 27.3987 27.1 24.2C28.6994 24.2 30 22.9922 30 21.5074V15.5C30 7.5047 23.4953 1 15.5 1Z",
    fill: "#09A3A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support_icon.cbed1fc62e8db7347f4a90522c8e1698.svg";
export { ForwardRef as ReactComponent };